import { isCWLActive, openCWLDialog } from 'lib/cwl/utils';
import { cn } from 'utils/cn';
import { type ComponentChildren } from 'preact';

type Props = {
	as?: 'a' | 'button' | 'div' | 'span';
	children: ComponentChildren;
	className?: string;
	classNameOverride?: string;
	cwlActive?: boolean;
	href?: string;
	target?: string;
	onClick?: (event: MouseEvent) => void;
	onContextMenu?: (event: MouseEvent) => void;
	onAuxClick?: (event: MouseEvent) => void;
};

export function Link({ as = 'a', cwlActive, classNameOverride, className, children, ...props }: Props) {
	const Tag = as;

	return (
		<Tag
			{...props}
			class={
				classNameOverride !== undefined
					? classNameOverride
					: cn(
							'border rounded-3xl border-solid border-neutral-20 hover:border-neutral-50 bg-surface-primary font-light text-red hover:text-red px-12 py-3 inline-block cursor-pointer',
							className,
						)
			}
			onClick={(event: MouseEvent) => {
				if (cwlActive && isCWLActive()) {
					event.preventDefault();
					openCWLDialog(props.href);
				}

				if (props.onClick) {
					props.onClick(event);
				}
			}}
			onContextMenu={(event: MouseEvent) => {
				if (cwlActive && isCWLActive()) {
					event.preventDefault();
					openCWLDialog(props.href);
				}

				if (props.onContextMenu) {
					props.onContextMenu(event);
				}
			}}
			// @ts-expect-error
			onauxclick={(event: MouseEvent) => {
				if (cwlActive && isCWLActive()) {
					event.preventDefault();
					openCWLDialog(props.href);
				}

				if (props.onAuxClick) {
					props.onAuxClick(event);
				}
			}}
		>
			{children}
		</Tag>
	);
}

export default Link;
